import {
  pathOr, evolve, F, T 
} from 'ramda';

// Actions
export const workHoursExportActions = {
  request: 'WORK_HOURS_EXPORT_REQUEST',
  success: 'WORK_HOURS_EXPORT_SUCCESS',
  fail: 'WORK_HOURS_EXPORT_FAIL',
  show: 'WORK_HOURS_EXPORT_SHOW',
  hide: 'WORK_HOURS_EXPORT_HIDE'
};

export const requestWorkHoursExport = () => ({ type: workHoursExportActions.request });
export const hideWorkHoursExport = () => ({ type: workHoursExportActions.hide });

// selectors
export const getWorkHoursExportStatus = pathOr({}, ['workHoursExport', 'export']);

// Reducer
const initialState = {
  fetching: false,
  errors: null,
  open: false
};

const requestEvolve = {
  fetching: T
};

const failEvolve = (errors) => ({
  fetching: F,
  errors: () => errors
});

const successEvolve = {
  fetching: F,
  errors: () => null
};

const showEvolve = { open: T };
const hideEvolve = { open: F };

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case workHoursExportActions.request: {
      return evolve(requestEvolve, state);
    }
    case workHoursExportActions.success: {
      return evolve(successEvolve, state);
    }
    case workHoursExportActions.fail: {
      return evolve(failEvolve(payload), state);
    }
    case workHoursExportActions.show: {
      return evolve(showEvolve, state);
    }
    case workHoursExportActions.hide: {
      return evolve(hideEvolve, state);
    }
    default:
      return state;
  }
};
